import { styled } from '@mui/material';
import { TextField } from '../../atoms/TextField';

export const StyledTextField = styled(TextField)`
  width: 200px;
  min-width: 200px;
`;
